import React from "react";
import Chart from "react-apexcharts";

const RadarChart = () => {
  const chartOptions = {
    chart: {
      type: "radar",
      toolbar: {
        show: false,
      },
    },
    title: {
      text: "OPERATED ZONES",
      align: "center",
      offsetY: 10,
      style: {
        fontSize: "20px",
        fontWeight: "600",
        color: "#000",
      },
    },
    xaxis: {
      categories: ["North", "East", "Central", "South", "West"],
    },
    fill: {
      opacity: 0.5,
      colors: ["#82b1ff"],
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#3d5afe"],
    },
    markers: {
      size: 4,
      colors: ["#fff"],
      strokeColors: "#3d5afe",
      strokeWidth: 2,
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: true,
      borderColor: "#e7e7e7",
    },
  };

  const chartSeries = [
    {
      name: "Zone Data",
      data: [40, 78, 22, 36, 138],
    },
  ];

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="radar"
        height="350"
      />
    </div>
  );
};

export default RadarChart;
